import React, { useState, useContext, createContext } from "react";

import Modal from "./Modal";
import News from "./News";
import useNewsScroll from "./hooks/useNewsScroll";
import Kv from "./Kv";
import EleBoard from "./EleBoard";
import Column from "./Column";
import Footer from "./Footer";
import CopyRights from "./CopyRights";
import SearchContent from "./SearchContent";
import Share from "./Share";
import Contact from "./Contact";
import BroadcastChannel from "./BroadcastChannel";
import TimetableSP from "./TimetableSP";

export default function Main() {
    const [data, setdata] = useState({
        idx: "21",
        day: ["day2"],
        category: ["entame"],
        programName:
            "文藝春秋１００周年オンライン・フェス特別企画 カトリガキク ワンハンドレッドクエスチョンズ！",
        channelId: "株式会社文藝春秋",
        channelIcon: "mi_books",
        performer1: {
            name: "香取慎吾",
            job: "",
            info: "1977年生まれ｡91年CDデビュー｡歌､芝居､バラエティから､ファッション､アートまで多方面で活躍｡2017年からは稲垣吾郎､草彅剛と｢新しい地図｣をスタート｡個展｢WHO AM I｣を開催中｡",
        },
        abstract:
            "創業100周年を迎える株式会社文藝春秋の社屋の前に､スーツ姿で現れたひとりの男｡カメラを従え､彼が向かったのはｰｰ｡創業者はあの文豪｡麻雀ブームの火付け役って本当⁉ 会社の中になぜBARが? 地下の巨大資料室で見つけたのは? そしてついに､あの編集部へ｡創刊4周年を迎える『週刊文春WOMAN』で表紙画を描くなど､文藝春秋とは浅からぬ縁のある香取慎吾がそこに集う人々を直撃取材｡〝ブンシュン〟を丸裸にする⁉ 出演:香取慎吾､『週刊文春』編集長､『文藝春秋』編集長､株式会社文藝春秋社長､その他社員大勢",
        movieLink: "wEA3QrTlQeY",
        thumbnailLink: "c_ent6_bura",
        thumbnailAlt:
            "文藝春秋１００周年オンライン・フェス特別企画 カトリガキク ワンハンドレッドクエスチョンズ！",
        titleStyleOption: "twoline",
        scheStyleOption: "oneline",
        hasUrgentTag: true,
    });

    const { isNewsActive } = useNewsScroll(300);

    const programs = {
        ID21: {
            idx: "21",
            day: ["day2"],
            category: ["entame"],
            programName:
                "文藝春秋１００周年オンライン・フェス特別企画 カトリガキク ワンハンドレッドクエスチョンズ！",
            channelId: "株式会社文藝春秋",
            channelIcon: "mi_books",
            performer1: {
                name: "香取慎吾",
                job: "",
                info: "1977年生まれ｡91年CDデビュー｡歌､芝居､バラエティから､ファッション､アートまで多方面で活躍｡2017年からは稲垣吾郎､草彅剛と｢新しい地図｣をスタート｡個展｢WHO AM I｣を開催中｡",
            },
            abstract:
                "創業100周年を迎える株式会社文藝春秋の社屋の前に､スーツ姿で現れたひとりの男｡カメラを従え､彼が向かったのはｰｰ｡創業者はあの文豪｡麻雀ブームの火付け役って本当⁉ 会社の中になぜBARが? 地下の巨大資料室で見つけたのは? そしてついに､あの編集部へ｡創刊4周年を迎える『週刊文春WOMAN』で表紙画を描くなど､文藝春秋とは浅からぬ縁のある香取慎吾がそこに集う人々を直撃取材｡〝ブンシュン〟を丸裸にする⁉ 出演:香取慎吾､『週刊文春』編集長､『文藝春秋』編集長､株式会社文藝春秋社長､その他社員大勢",
            movieLink: "wEA3QrTlQeY",
            thumbnailLink: "c_ent6_bura",
            thumbnailAlt:
                "文藝春秋１００周年オンライン・フェス特別企画 カトリガキク ワンハンドレッドクエスチョンズ！",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
            hasUrgentTag: true,
        },
        ID1: {
            idx: "01",
            day: ["day1"],
            category: ["sports"],
            programName: "「僕のサッカー人生とこれからのこと」",
            channelId: "Sports Graphic Number",
            channelIcon: "mi_sports",
            performer1: {
                name: "中村俊輔",
                job: "プロサッカー選手",
                info: "1978年､神奈川県生まれ｡97年に横浜マリノス入団｡レッジーナ､セルティック､エスパニョールを経て､10年に横浜F･マリノスに復帰｡その後､磐田､横浜FCに在籍｡日本代表では98試合出場24得点｡",
            },
            abstract:
                "今シーズンをもって､26年間に及ぶ現役生活にピリオドを打つことを決めた中村俊輔さんがオープニングプログラムに登場｡マリノス､レッジーナ､セルティック･･･､そして日本代表でたくさんの栄光をつかんできた稀代の選手が､その人生を振り返る｡日本代表の10番をつとめるプレッシャーとは? 代表の試合で忘れられないゴールは? 気になる今後の人生についてもじっくり聞く｡開催中のサッカーワールドカップのレビューも｡",
            movieLink: "csVj34FWm4o",
            thumbnailLink: "c_sports1_soccer",
            thumbnailAlt: "「僕のサッカー人生とこれからのこと」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID2: {
            idx: "02",
            day: ["day1"],
            category: ["entame"],
            programName: "「きょんリサ・トークライブ」",
            channelId: "文春オンライン",
            channelIcon: "mi_online",
            performer1: {
                name: "柳家喬太郎",
                job: "落語家",
                info: "1989年柳家さん喬に入門､前座名｢さん坊｣｡1993年二ツ目昇進､｢喬太郎｣と改名｡2000年真打昇進｡2014年落語協会理事に就任｡2020年落語協会常任理事に就任｡",
            },
            performer2: {
                name: "伊藤理佐",
                job: "漫画家",
                info: "1969年生まれ｡87年デビュー｡『おるちゅばんエビちゅ』『おいピータン!!』など作品多数｡朝日新聞ではエッセイ『オトナになった女子たちへ』も連載｡週刊文春の人気連載『おんなの窓』は19年目に入る｡",
            },
            abstract:
                '実は｢週刊文春｣での連載暦が共に19年という"同期"のお二人｡かつては一緒に酒場へ繰り出すこともあった仲だが､コロナ禍以降ひさしぶりの対決､じゃなくて対面ｰｰ｡片や押しも押されもせぬ人気落語家､片や天然と天才が同居する人気漫画家｡共に下ネタ好き｡放送事故も覚悟して臨む､制限時間1時間強のぶっつけフリートークです｡',
            movieLink: "O7PP1CvSaws",
            thumbnailLink: "c_ent1_kyon",
            thumbnailAlt: "「きょんリサ・トークライブ」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID3: {
            idx: "03",
            day: ["day1"],
            category: ["kokusai"],
            programName: "「“沈みゆく世界”から立ち上がる」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "國分功一郎",
                job: "哲学者",
                info: "1974年生まれ｡東京大学大学院総合文化研究科博士課程修了｡博士(学術)｡東京大学大学院総合文化研究科･教養学部准教授｡専門は哲学･現代思想｡著書に『暇と退屈の倫理学』『中動態の世界』『スピノザ』など｡",
            },
            performer2: {
                name: "ブレイディみかこ",
                job: "ライター､コラムニスト",
                info: "1965年生まれ｡96年から英国ブライトン在住｡ライター､コラムニスト｡著書に『子どもたちの階級闘争』『ぼくはイエローでホワイトで､ちょっとブルー』『他者の靴を履く』『両手にトカレフ』など｡",
            },
            abstract:
                "物価高と生活危機の問題がいよいよ深刻化し､庶民が立ち上がり始めたイギリスｰｰ｡一方､円安が市民の生活を直撃するなかで､統一教会問題から国葬問題まで激震が走る日本｡\nスピノザ哲学から自由の根源的な意味を探究してきた國分功一郎さんと､『他者の靴を履く』でエンパシーによる新しい突破口を示したブレイディみかこさんが存分に語り合います｡",
            movieLink: "8kQb1HNRTcc",
            thumbnailLink: "c_kokusai1_sizumiyukusekai",
            thumbnailAlt: "「“沈みゆく世界”から立ち上がる」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID4: {
            idx: "04",
            day: ["day1"],
            category: ["seizi"],
            programName: "「大座談会“目覚めよ！日本”」",
            channelId: "文藝春秋電子版",
            channelIcon: "mi_denshi",
            performer1: {
                name: "三浦瑠麗",
                job: "国際政治学者",
                info: "1980年生まれ｡山猫総合研究所代表｡国際政治理論と比較政治が専門｡東京大学大学院法学政治学研究科総合法政専攻博士課程修了､博士(法学)｡東京大学政策ビジョン研究センター講師などを経て現職｡",
            },
            performer2: {
                name: "成田悠輔",
                job: "経済学者､データ科学者",
                info: "専門は､データ･アルゴリズム･ポエムを使ったビジネスと公共政策の想像とデザイン｡著書に『22世紀の民主主義:選挙はアルゴリズムになり､政治家はネコになる』など",
            },
            performer3: {
                name: "中野信子",
                job: "脳科学者",
                info: "1975年生まれ｡東大工学部応用化学科卒業､同大学院医学系研究科脳神経医学専攻博士課程修了｡2008年から10年までフランス国立研究所ニューロスピンに勤務｡東日本国際大学特任教授､京都芸術大学客員教授",
            },
            performer4: {
                name: "東浩紀",
                job: "批評家・作家",
                info: "1971年東京都生まれ｡東京大学大学院博士課程修了｡専門は現代思想､表象文化論､情報社会論｡93年に批評家としてデビュー､早稲田大学教授など歴任｡2010年に株式会社ゲンロンを創業､現在同社取締役",
            },
            performer5: {
                name: "先崎彰容",
                job: "批評家",
                info: "1975年東京都生まれ｡東京大学文学部倫理学科卒業｡文学博士｡日本大学危機管理学部教授｡専攻は近代日本思想史･日本倫理思想史｡主な著書に『未完の西郷隆盛ｰｰ日本人はなぜ論じ続けるのか』(新潮選書)など",
            },
            performer6: {
                name: "(MC) 新谷学",
                job: "｢文藝春秋｣編集長",
                info: "1964年､東京都出身｡早稲田大学政治経済学部政治学科卒業後､1989年文藝春秋に入社｡2012年4月｢週刊文春｣編集長｡2021年7月より｢文藝春秋｣編集長に就任(執行役員兼務)",
            },
            abstract:
                "ウクライナ戦争から元首相暗殺､日本経済､皇位継承問題まで､2022年は｢国家の在り方｣を問われる数々の問題が日本に降り掛かりました｡これらの課題に日本人はどう向き合い､乗り越えていけばいいのでしょうか? 当代一流の論客による議論によって､2023年の論点を浮き彫りにする3時間の大座談会｡後半2時間は｢文藝春秋 電子版｣での有料配信になります",
            movieLink: "l3NqIn47_fs",
            thumbnailLink: "c_seizi_daizadannkai",
            thumbnailAlt: "「大座談会“目覚めよ！日本”」",
            titleStyleOption: "twoline",
            scheStyleOption: "twoline",
            chargeMovieLink: "https://bunshun.jp/bungeishunju/articles/h4786",
            chargeMovieBuuton: "c_seizi_daizadannkai_fullbutton",
        },
        ID5: {
            idx: "05",
            day: ["day1"],
            category: ["history"],
            programName: "「作家？　文春創業者？　菊池寛とは何者か」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "門井慶喜",
                job: "作家",
                info: "1971年群馬県生まれ｡同志社大学文学部卒｡2003年｢キッドナッパーズ｣でオール讀物推理小説新人賞を受賞｡2018年『銀河鉄道の父』で直木賞を受賞｡現在､オール讀物で菊池寛が主人公の歴史小説を連載中",
            },
            performer2: {
                name: "春風亭小朝",
                job: "落語家",
                info: "1955年､東京生まれ｡70年に春風亭柳朝に入門｡80年36人抜きで真打昇進｡落語家のほか俳優としても活躍｡20年紫綬褒章受章｡菊池寛の短編小説に魅了され､2016年からリスペクト落語を発表してきた｡",
            },
            abstract:
                "文藝春秋創業者にして､『真珠夫人』などのベストセラー作家でもあった菊池寛｡\nその知られざる実像に､歴史小説の第一人者であり､現在｢オール讀物｣で､菊池寛をテーマに小説を執筆中の直木賞作家･門井慶喜と､菊池寛の小説世界に魅せられてリスペクト落語を発表してきた､〝落語の天才〟春風亭小朝が迫る!",
            movieLink: "2zJpQ5q_YsI",
            thumbnailLink: "c_history1_sakka",
            thumbnailAlt: "「作家？　文春創業者？　菊池寛とは何者か」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID6: {
            idx: "06",
            day: ["day1"],
            category: ["entame"],
            programName: "「ブルーは熱い色」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "橘ケンチ",
                job: "EXILE",
                info: "09年EXILE加入｡のちEXILE THE SECONDリーダーに｡役者としても活躍､23年1月よりミュージカル『チェーザレ 破壊の創造者』出演｡2月よりEXILE THE SECOND全国ツアー",
            },
            performer2: {
                name: "三浦しをん",
                job: "作家",
                info: "作家｡2000年､『格闘する者に○(まる)』でデビュー｡06年『まほろ駅前多田便利軒』で直木賞､12年『舟を編む』で本屋大賞受賞など受賞歴多数｡エッセイの名手としても知られる",
            },
            abstract:
                "唯一無二の表現に挑み続けるEXILEのパフォーマー･橘ケンチと､人気作家･三浦しをん! 圧倒的なヴォイスと独自のカラーを持つおふたりは､いかにして自らの｢声｣と｢色｣を獲得し､確立させたのか?\nあらゆる表現者が喉から手が出るほど欲しい｢個性｣を早くから獲得し､年代に応じて進化させ続けてきたおふたりの｢感性の鍛え方｣と､その源にある｢一生ものの体験｣について､語り尽くします!\nキーワードは｢ブルー｣｡橘ケンチさんからの発表もあります… どうぞお楽しみに!",
            movieLink: "pVOdBMfooWw",
            thumbnailLink: "c_ent5_blue",
            thumbnailAlt: "「ブルーは熱い色」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID7: {
            idx: "07",
            day: ["day1"],
            category: ["entame"],
            programName: "｢“時を超える”アニメーション制作の片隅に｣",
            channelId: "文春オンライン",
            channelIcon: "mi_online",
            performer1: {
                name: "片渕須直",
                job: "アニメーション監督",
                info: "日大芸術学部映画学科在学中に宮崎駿の｢名探偵ホームズ｣に脚本参加｡『マイマイ新子と千年の魔法』『この世界の片隅に』『この世の(さらにいくつもの)片隅に』等を監督｡『枕草子』清少納言に関する新作制作中｡",
            },
            performer2: {
                name: "ゆうきまさみ",
                job: "漫画家",
                info: "1980年､｢OUT｣掲載の｢ざ・ライバル｣でデビュー｡『究極超人あ～る』『機動警察パトレイバー』『じゃじゃ馬グルーミン★UP!』『ゆうきまさみのはてしない物語』等ヒット作多数｡｢新九郎、奔る!｣を連載中｡",
            },
            abstract:
                "アニメーション映画監督･片渕須直氏は､じつは疫病の最中にあった清少納言と『枕草子』の時代を描く新作に取り組んでいる｡各種史料と向き合い､多くの発見･新解釈を､SNSや講演などで発表｡話題を呼んでいる｡\n漫画家･ゆうきまさみが連載中の『新九郎､奔る!』は､後世｢北条早雲｣の名で知られる伊勢新九郎盛時が､主人公｡これまで言われてきた｢早雲像｣に囚われない表現は､歴史ファンにも衝撃を与えている｡\n自ら史料にあたり､解釈し､作品に落とし込んでいく試みに取り組んでいる2人が､｢時空を超えた場所に､現代の読者をいかに連れていくか｣について語る｡",
            movieLink: "q45RIBwUbRk",
            thumbnailLink: "c_ent_ziku",
            thumbnailAlt: "｢“時を超える”アニメーション制作の片隅に｣",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID8: {
            idx: "08",
            day: ["day2"],
            category: ["gurume"],
            programName: "note×文藝春秋「わたしたちの“ご自愛”レシピ」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "今井真実",
                job: "料理家",
                info: "雑誌､web媒体､企業広告にて多岐にわたるレシピ製作を担当｡noteで発信するレシピや日々の暮らしを綴った文章が注目を集める｡著書に『いい日だった､と眠れるように 私のための私のごはん』など",
            },
            performer2: {
                name: "大木亜希子",
                job: "作家",
                info: "2005年女優デビュー｡10年､SDN48に加入｡19年､実録私小説『人生に詰んだ元アイドルは､赤の他人のおっさんと住む選択をした』が話題に｡22年3月､短篇小説集『シナプス』を刊行",
            },
            abstract:
                "｢作った人が嬉しくなる料理を｣をモットーに､公開するたびにそのレシピが話題を呼ぶ今井真実さん｡｢人生に詰んだ｣元アイドルにして､noteで発表した小説｢シナプス｣で悩める女子たちから圧倒的な共感を集めた大木亜希子さん｡ともにnoteに等身大の姿を綴ってこられたお二人による､夢のコラボレーションが実現｡\n“お疲れ女子”大木さんのお悩みを解決する､今井さんのスペシャルレシピとは? しんどい夜を救ってくれる〈ご自愛〉料理を一緒につくりましょう｡noteキッチンスタジオからお届けします｡",
            movieLink: "0XiN4SwXTEY",
            thumbnailLink: "c_gurume1_watashitati",
            thumbnailAlt: "note×文藝春秋「わたしたちの“ご自愛”レシピ」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID9: {
            idx: "09",
            day: ["day2"],
            category: ["history"],
            programName: "「天下人・徳川家康の“人事”のこと」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "磯田道史",
                job: "歴史学者",
                info: "1970年岡山県生まれ｡国際日本文化研究センター教授｡著書に『武士の家計簿』『龍馬史』『無私の日本人』『感染症の日本史』など｡",
            },
            abstract:
                "家康とは､どんな先祖から発生した家族の出なのか｡一族の気質､天下人への分岐点となったある私的な出来事､そして､｢人使い｣の奥義とは｡｢家康が天下をとれた背景｣を､｢人事｣を中心に紐解く!テレビの歴史番組でもおなじみ､気鋭の歴史学者による熱い講義をお楽しみに｡",
            movieLink: "GSHjFvTDfIQ",
            thumbnailLink: "c_history2_tenkanin",
            thumbnailAlt: "「天下人・徳川家康の“人事”のこと」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID10: {
            idx: "10",
            day: ["day2"],
            category: ["gurume"],
            programName: "「最新版　東京いい店うまい店」",
            channelId: "CREA WEB",
            channelIcon: "mi_crea",
            performer1: {
                name: "小宮山雄飛",
                job: "ホフディラン",
                info: "1973年東京都出身｡ホフディランのVo&Key担当｡ミュージシャンのかたわらグルメにも精通し､雑誌連載やカレーレシピ本出版など食のシーンでも活躍｡地元渋谷区の観光大使も務める｡",
            },
            abstract:
                "食のインフルエンサーとしても有名な小宮山雄飛さんと一緒に､ビフォーコロナ､アフターコロナの食トレンドを分析しながら､今後の食文化の在り方について議論をする｡日本中の美味しい飲食店やお取り寄せの話題も散りばめていきます",
            movieLink: "ujuqrNOOLwQ",
            thumbnailLink: "c_gurume_saishinban",
            thumbnailAlt: "「最新版　東京いい店うまい店」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID11: {
            idx: "11",
            day: ["day2"],
            category: ["entame"],
            programName: "コロナ禍で考えた「表現する」ということ",
            schedule: "15:00~16:00",
            channelId: "文藝春秋電子版",
            channelIcon: "mi_denshi",
            performer1: {
                name: "小林直己",
                job: "EXILE/三代目J SOUL BROTHERSのメンバー",
                info: '千葉県出身｡EXILE/三代目 J SOUL BROTHERSのメンバー｡著書に『選択と奇跡 あの日､僕の名字はEXILEになった』｡2月よりアリーナツアー｢三代目 J SOUL BROTHERS LIVE TOUR 2023 "STARS" ~Land of Promise~｣開催｡',
            },
            performer2: {
                name: "千葉雅也",
                job: "哲学者･作家",
                info: "東京大学大学院総合文化研究科博士課程修了｡博士(学術)｡現在は立命館大学大学院先端総合学術研究科教授｡著書に『勉強の哲学』『アメリカ紀行』『デッドライン』『オーバーヒート』『現代思想入門』など｡",
            },
            abstract:
                "EXILEのパフォーマーであり俳優の小林直己さんと､哲学者であり作家の千葉雅也さんは､コロナ禍真っ最中の2020年秋､｢文學界｣対談で初の対面を果たしました｡今回は､約2年ぶりの再会｡お二人にとってコロナは､自分の居場所や時間の過ごし方､仕事への向き合い方について見つめ直す､大きな転機となったようです｡文章を書くこと､身体やこころの整え方のみならず､いまハマっていることについてもお二人にお聞きしました｡向こう10年間を自分らしく楽しんで生きるためのヒントがぎっしり詰まった刺激的な対談､ぜひお聞きください｡",
            movieLink: "NMN3jTkNjUE",
            thumbnailLink: "c_ent_korona",
            thumbnailAlt: "コロナ禍で考えた「表現する」ということ",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID12: {
            idx: "12",
            day: ["day2"],
            category: ["bungaku"],
            programName: "「How to 本の装幀」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "大久保明子",
                job: "装幀家",
                info: "埼玉県出身｡多摩美術大学デザイン科グラフィックデザイン専攻卒業後､文藝春秋デザイン部に入社｡第38回講談社出版文化賞ブックデッザイン賞受賞",
            },
            performer2: {
                name: "(聞き手) 阿川佐和子",
                job: "作家･エッセイスト",
                info: "慶應義塾大学文学部卒｡『聞く力』が2012年年間ベストセラー総合1位に｡｢週刊文春｣の連載対談を30年､『ビートたけしのTⅤタックル』のMCを20年以上つとめる｡近年は女優としても活躍",
            },
            abstract:
                "創業以来､文藝春秋は数多のベストセラー&話題作を刊行してきました｡それら作品を彩るのが､イラストや写真､タイトル文字を生かした装幀です｡読者の目を引くデザイン､思わず手に取りたくなるような本は､いったいどのようにして生まれるのでしょうか? これまで村上春樹『色彩を持たない多崎つくると､彼の巡礼の年』や又吉直樹『火花』､瀬尾まいこ『そして､バトンは渡された』など､印象的なベストセラーを数々手掛けてきた文藝春秋デザイン部の大久保明子が､興味津々の阿川佐和子を聞き手にとっておきの装幀術を語ります｡",
            movieLink: "vWS3oFUYNgI",
            thumbnailLink: "c_bungaku1_howto",
            thumbnailAlt: "「How to 本の装幀」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID13: {
            idx: "13",
            day: ["day2"],
            category: ["entame"],
            programName: "「世界で弾く、世界を弾く」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "藤田真央",
                job: "ピアニスト",
                info: "1998年生｡2019年チャイコフスキー国際コンクール第2位｡国内外の有名オケとの共演多数｡22年10月『モーツァルト:ピアノ･ソナタ全集』で世界デビュー｡23年1月カーネギーホールでリサイタル決定",
            },
            abstract:
                "2019年､弱冠20歳にしてチャイコフスキー国際コンクールで第2位入賞｡以降､イノセントで自由な音色と独自の楽曲解釈で､クラシック音楽シーンを更新しつづけている藤田真央さん｡現在はベルリンに拠点を移し､ヴェルビエ音楽祭､ルツェルン音楽祭といった最高峰の舞台で観客を熱狂させています｡\n一流オーケストラと呼吸をあわせ､レジェンド指揮者と魂の音楽を紡ぐ｡そこには本物のスターのみが見ることを許される景色があることでしょう｡一時帰国中の藤田さんに､｢世界を奏でる｣日々について存分に語っていただきます｡",
            movieLink: "wgM9gwQ9F3U",
            thumbnailLink: "c_ent2_sekaidehiku",
            thumbnailAlt: "「世界で弾く、世界を弾く」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID14: {
            idx: "14",
            day: ["day2"],
            category: ["bungaku"],
            programName: "「プロ“作家”になった三者三様の方法論」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "阿部智里",
                job: "作家",
                info: "1991年､群馬県前橋市生まれ｡12年『烏に単は似合わない』が史上最年少の20歳で第19回松本清張賞を受賞｡デビュー作から続く｢八咫烏｣シリーズは累計部数180万部を超える大ヒットに｡",
            },
            performer2: {
                name: "額賀澪",
                job: "作家",
                info: "1990年､茨城県生まれ｡2015年『屋上のウインドノーツ』で第22回松本清張賞､『ヒトリコ』で第16回小学館文庫小説賞受賞｡以降､青春小説やスポーツ小説を中心に数多くの作品を上梓｡",
            },
            performer3: {
                name: "坂上泉",
                job: "作家",
                info: "1990年兵庫県生まれ｡2019年｢明治大阪へぼ侍 西南戦役遊撃壮兵実記｣で第26回松本清張賞を受賞｡同作を改題した『へぼ侍』でデビュー｡2作目の『インビジブル』で大藪春彦賞､日本推理作家協会賞｡",
            },
            abstract:
                "松本清張賞を20代で受賞してプロ作家デビューを果たした若き注目作家の三人｡それぞれファンタジー､青春&スポーツ､歴史とジャンルは異なりますが､話題作を次々に上梓しています｡幼い頃からの｢作家になる｣夢を実現させるまでの学生時代と文学賞への投稿時代､長編小説をどのように書き上げればプロとして認められるのかｰｰ作家志望の方はもちろん､小説好きにはたまらない三者三様の創作論に迫ります! (MC:川田未穂｢オール讀物｣編集長)",
            movieLink: "HxZMSSIB3_s",
            thumbnailLink: "c_bungaku2_pro",
            thumbnailAlt: "「プロ“作家”になった三者三様の方法論」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID15: {
            idx: "15",
            day: ["day2"],
            category: ["kokusai"],
            programName: "「2023年のアメリカを展望する」",
            channelId: "文藝春秋電子版",
            channelIcon: "mi_denshi",
            performer1: {
                name: "池上彰",
                job: "ジャーナリスト",
                info: "1950年長野県生まれ｡慶應義塾大学経済学部卒｡73年NHK入局｡94年から｢週刊こどもニュース｣で解説を担当｡2005年NHKを退職しフリーに｡『伝える力』『池上彰の世界の見方』など著書多数",
            },
            abstract:
                "今年11月中間選挙を現地で取材するなど､アメリカ取材を重ねている池上氏｡ウクライナ紛争とどう向き合うのか､大国中国との覇権争いはいかに展開するのか､2年後に迫った大統領選挙は再びバイデンvs.トランプとなるのか､記録的なインフレは終息するのか､など2023年のアメリカを展望する今年11月中間選挙を現地で取材するなど､アメリカ取材を重ねている池上氏｡",
            movieLink: "a1e1k552ZvQ",
            thumbnailLink: "c_kokusai2_2023",
            thumbnailAlt: "「2023年のアメリカを展望する」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID17: {
            idx: "16",
            day: ["day2"],
            category: ["bungaku"],
            programName: "「消えゆく美しい日本語」",
            channelId: "本の話Web",
            channelIcon: "mi_story",
            performer1: {
                name: "浅田次郎",
                job: "作家",
                info: "1951年東京都生まれ｡97年『鉄道員』で直木賞､2000年『壬生義士伝』で柴田錬三郎賞､08年『中原の虹』で吉川英治文学賞など受賞多数｡15年､紫綬褒章受章｡来年『大名倒産』が映画化､公開予定｡",
            },
            abstract:
                "日々､新しい言葉が生まれる一方で､忘れられ消えゆく言葉もあります｡｢一つの言葉が消えることは､一つの思想が消えること｣と語る､文壇きっての名文家･浅田次郎が100年後に残したい､美しい日本語とは!?",
            movieLink: "Dca3tV3njNA",
            thumbnailLink: "c_bungaku3_kieyuku",
            thumbnailAlt: "「消えゆく美しい日本語」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID16: {
            idx: "17",
            day: ["day2"],
            category: ["kokusai"],
            programName: "「ウクライナの2023年“戦場の虚と実”」",
            channelId: "文藝春秋電子版",
            channelIcon: "mi_denshi",
            performer1: {
                name: "小泉悠",
                job: "東京大学専任講師",
                info: "1982年生まれ｡早稲田大学大学院政治学研究科修士課程修了｡外務省専門分析員､未来工学研究所研究員､国立国会図書館非常勤調査員などを経て､東京大学先端科学技術研究センター専任講師｡ロシア軍事研究が専門",
            },
            performer2: {
                name: "砂川文次",
                job: "作家",
                info: "1990年大阪府生まれ｡公務員｡元自衛官｡2016年｢市街戦｣で第121回文學界新人賞を受賞し､デビュー｡｢戦場のレビヤタン｣｢小隊｣が芥川賞候補作に｡｢ブラックボックス｣で第166回芥川賞を受賞",
            },
            performer3: {
                name: "高橋杉雄",
                job: "防衛研究所防衛政策研究室長",
                info: "1972年生まれ｡早稲田大学大学院政治学研究科修士課程修了､ジョージワシントン大学コロンビアンスクール修士課程修了｡国際安全保障論､現代軍事戦略論、日米関係論が専門",
            },
            performer4: {
                name: "(MC) 新谷学",
                job: "｢文藝春秋｣編集長",
                info: "1964年､東京都出身｡早稲田大学政治経済学部政治学科卒業後､1989年文藝春秋に入社｡2012年4月｢週刊文春｣編集長｡2021年7月より｢文藝春秋｣編集長に就任(執行役員兼務)",
            },
            abstract:
                "圧倒的な火力でロシア優勢だった戦況が､秋以降はウクライナが反転攻勢を見せ､年を越すことがほぼ確実な情勢のウクライナ戦争｡2023年はどのような展開になるのか｡元自衛官であり､日本とロシアの戦争を描いた『小隊』作者の砂川氏と､軍事の専門家である小泉氏と高橋氏の3人が分析する､3時間のマニアック座談会｡後半2時間は｢文藝春秋 電子版｣での有料配信になります",
            movieLink: "iCaWgqp3qUc",
            thumbnailLink: "c_kokusai3_ukraine",
            thumbnailAlt: "「ウクライナの2023年“戦場の虚と実”」",
            titleStyleOption: "twoline",
            scheStyleOption: "twoline",
            chargeMovieLink: "https://bunshun.jp/bungeishunju/articles/h4787",
            chargeMovieBuuton: "c_kokusai3_ukraine_fullbutton",
        },
        ID18: {
            idx: "18",
            day: ["day2"],
            category: ["entame"],
            programName:
                "誰からも好かれる！　好感度抜群！「セント・フォース流ヘアメイクの極意」",
            schedule: "19:15~20:15",
            channelId: "株式会社文藝春秋",
            channelIcon: "mi_books",
            performer1: {
                name: "谷尻萌",
                job: "セント･フォース キャスター",
                info: "たにじりもえ 1999/02/10生まれ｡京都府出身｡身長164㎝｡同志社大学社会学部メディア学科卒｡｢めざましテレビ｣｢めざましどようび｣(フジテレビ)お天気キャスター｡",
            },
            performer2: {
                name: "野田心優",
                job: "セント･フォース キャスター",
                info: "のだみゆう 2003/07/12生まれ｡東京都出身｡身長155㎝｡早稲田大学文化構想学部文化構想学科在学中｡｢gee up sprout｣(FM Salus)出演中｡2020年ポカリスエットCM出演｡",
            },
            abstract:
                "皆藤愛子､新井恵理那､鷲見玲奈等､人気キャスターが数多く所属するセント･フォースが主催､不定期開催されている｢ヘアメイク講座｣｡アナウンサーを目指す女子大生だけでなく､現役アナウンサーも受講する人気講座です｡その門外不出の講義内容をライブ中継｡野田美優さんのすっぴんから､メイクが仕上がっている過程を､かんだゆうこさんの解説､谷尻萌さんの質問を挟みながら展開します｡あらゆる年代から好感を持たれるセント･フォース流ヘアメイクとは?",
            movieLink: "dICyinhcoQQ",
            thumbnailLink: "c_ent3_centforce",
            thumbnailAlt:
                "誰からも好かれる！　好感度抜群！「セント・フォース流ヘアメイクの極意」",
            titleStyleOption: "twoline",
            scheStyleOption: "oneline",
        },
        ID19: {
            idx: "19",
            day: ["day2"],
            category: ["sports"],
            programName: "「甲子園決勝で投げる醍醐味」",
            schedule: "19:15~20:15",
            channelId: "Sports Graphic Number",
            channelIcon: "mi_sports",
            performer1: {
                name: "松坂大輔",
                job: "野球評論家",
                info: "横浜高等学校出身｡甲子園春夏連覇｡1998年西武ライオンズ入団｡2006年ボストン･レッドソックスと契約｡その後､肘の手術を受け､2015年に日本球界復帰､2021年シーズンをもって現役引退した｡",
            },
            performer2: {
                name: "斎藤佑樹",
                job: "実業家･元プロ野球選手",
                info: "早稲田大学出身｡早実では夏の甲子園優勝｡2010年日本ハムに入団し､ルーキーイヤーから6勝をマークした｡2021年シーズンをもって現役引退､同年12月｢株式会社斎藤佑樹｣を設立し代表取締役に就任｡",
            },
            abstract:
                "1998年の甲子園では春夏連覇し｢平成の怪物｣と呼ばれた松坂大輔さん｡そして2006年夏の甲子園決勝で駒大苫小牧と熱戦を繰り広げ､｢ハンカチ王子｣として一世を風靡した斎藤佑樹さん｡多くの人を感動させる甲子園の魅力や､世間の注目を浴びた高校時代の光と影､プロ時代に悩まされたケガについて､2人はどのように考えていたのでしょうか｡そして、侍ジャパンの注目選手や今後の活動まで､“怪物と王子”が縦横無尽に語り合います｡司会･吉井妙子",
            movieLink: "0nl169KABPk",
            thumbnailLink: "c_sports2_koshien",
            thumbnailAlt: "「甲子園決勝で投げる醍醐味」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
        ID20: {
            idx: "20",
            day: ["day2"],
            category: ["entame"],
            programName: "「鎌倉殿と菊池寛と女優」",
            schedule: "20:15~21:45",
            channelId: "CREA WEB",
            channelIcon: "mi_crea",
            performer1: {
                name: "阿川佐和子",
                job: "作家･エッセイスト",
                info: "慶應義塾大学文学部卒｡『聞く力』が2012年年間ベストセラー総合1位に｡｢週刊文春｣の連載対談を30年､『ビートたけしのTVタックル』のMCを20年以上つとめる｡近年は女優としても活躍",
            },
            performer2: {
                name: "三谷幸喜",
                job: "脚本家･演出家",
                info: "日本大学芸術学部卒｡1983年劇団｢東京サンシャインボーイズ｣を結成｡以降､ドラマ『古畑任三郎』シリーズ､映画『THE 有頂天ホテル』などがヒット｡2022年NHK大河ドラマ『鎌倉殿の13人』が話題に",
            },
            abstract:
                "脚本を手がけたNHK大河ドラマ『鎌倉殿の13人』が大いに話題となり､先日､菊池寛賞を受賞したばかりの三谷幸喜さん｡いっぽう､その菊池寛賞選考委員で､来年公開の映画『エゴイスト』では重い病を抱える母親役を熱演している阿川佐和子さん｡実はお2人はプライベートでも親交のある気心の知れた仲｡まずは三谷さんのドラマヒットと受賞をお祝いするところからトークが始まりますが､話は脱線につぐ脱線で､どこに向かうのか予測不能､だけど絶対面白い対談です",
            movieLink: "ZF28aiLsd7o",
            thumbnailLink: "c_ent4_kamakura",
            thumbnailAlt: "「鎌倉殿と菊池寛と女優」",
            titleStyleOption: "oneline",
            scheStyleOption: "oneline",
        },
    };
    const [newsAddAnimTrigger, setNewsAddAnimTrigger] = useState(true);

    return (
        <div className="main" id="main">
            <Modal data={data} setdata={setdata} />
            <TimetableSP isActive={!isNewsActive} />
            <News isActive={isNewsActive} isLoad={newsAddAnimTrigger} />
            <Kv />
            <EleBoard />
            <Column />
            <BroadcastChannel />
            <SearchContent data={programs} setdata={setdata} />
            <Contact />
            <Share />
            <Footer />
            <CopyRights />
        </div>
    );
}
